// Main js file for the object
function blog() {
  console.log('blog');
}

export default blog;
